import { MediaType, validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, DESPACHANTE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    DESPACHANTE_ENDPOINT, 'filter'
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      DESPACHANTE_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    DESPACHANTE_ENDPOINT,
    id
  ]);
}

export async function register(data, queryParams = [], config = {}) {
  return doPostQCXRequest(
    [DESPACHANTE_ENDPOINT],
    data,
    queryParams,
    {
      ...config,
      headers: {
        'Content-Type': MediaType.MULTIPART_FORM_DATA,
      },
    }
  );
}

export async function save(data, queryParams = [], config = {}) {
  return doPutQCXRequest(
    [DESPACHANTE_ENDPOINT],
    data,
    queryParams,
    {
      ...config,
      headers: {
        'Content-Type': MediaType.MULTIPART_FORM_DATA,
      },
    }
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [DESPACHANTE_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [DESPACHANTE_ENDPOINT],
    id
  );
}
